module.exports = __webpack_public_path__ + "static/media/notificationIcon.a4c4d6c3.svg";